import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import { IconButton, Tooltip } from '@mui/material';
export default function LogoIconButton({logo, ...props }) {
    return (
        <Tooltip title={!!logo ? "Logo" : "Sem logo"}>
            <IconButton {...props}>
                <InsertPhotoIcon sx={{ color: !!logo  ? "#00a7e1" : "red"}} size="small" ></InsertPhotoIcon>
            </IconButton>
        </Tooltip>
    )
}